'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = require('decisiv-ui-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = function styles(_ref) {
  var theme = _ref.theme;
  return '\n  border-bottom: 1px solid ' + theme.colors.base.chrome200 + ';\n  cursor: default;\n  display: flex;\n\n  &:hover {\n    background: ' + theme.colors.base.chrome100 + ';\n  }\n\n  th, td {\n    flex: 1;\n  }\n';
};

var modifierConfig = {
  noHighlightOnHover: function noHighlightOnHover() {
    return '\n    &:hover {\n      background: none;\n    }\n  ';
  },
  notFlex: function notFlex() {
    return '\n    display: table-row;\n\n    th, td {\n      min-width: 0;\n    }\n  ';
  }
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome100: _propTypes2.default.string.isRequired,
      chrome200: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Table__Row', _styledComponents2.default.tr, styles, {
  modifierConfig: modifierConfig,
  themePropTypes: themePropTypes
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/blocks/Table/Row.js
// module id = 1606
// module chunks = 2